exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._37f2GxKDsLSyr_j6Cet-xZ{font-size:14px;font-weight:400;color:\"[theme:neutralSecondary, default:#666666]\"}html[dir] ._37f2GxKDsLSyr_j6Cet-xZ{margin-top:0}", ""]);

// exports
exports.locals = {
	"description": "_37f2GxKDsLSyr_j6Cet-xZ"
};